module.exports = __webpack_public_path__ + "media/configurations/P-SX-e579f10d.png";